import { createAsyncThunk } from '@reduxjs/toolkit'
import type {DefaultRootState} from './coreReducer'

const stateCLEARSTORAGE: ReturnType<typeof createAsyncThunk<void, void, { state: DefaultRootState }>> =
	createAsyncThunk<void, void, { state: DefaultRootState }>('_internal:state:clearStorage', async _ => {
		return new Promise<void>(resolve => {
			resolve()
		})
	})

export { stateCLEARSTORAGE }
